import { Component, OnInit, ViewChild, TemplateRef, EventEmitter, Output, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { DataColumn, DatagridComponent } from '@farris/ui-datagrid';
import { DialogComponent } from '@farris/ui-dialog';
import { LookupGridComponent, PickedResult } from '@farris/ui-lookup';
import { MessagerService } from '@farris/ui-messager';
import { Observable, of } from 'rxjs';
import { ProcessDesignerUIState } from '../../../app/process-designer.uistate';
import { MessageNoticeBatchSet } from '../message-notice-batchSet';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../i18n/assets/lang.resource';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../i18n/pipe/wf-process-editor-locale.pipe';

@Component({
  selector: 'lib-message-notice-copy',
  templateUrl: './message-notice-copy.component.html',
  styleUrls: ['./message-notice-copy.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class MessageNoticeCopyComponent implements OnInit {
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @Output() closeEmitter = new EventEmitter<any>();
  @Output() submitEmitter = new EventEmitter<any>();
  // 活动节点表信息============================================
  @ViewChild('allActisTable') allActisTable: DatagridComponent;
  @ViewChild('allActisDialog') allActisDialog: DialogComponent;
  @ViewChild('actTable') actTable: DatagridComponent;
  @ViewChild('lookup') lookup: LookupGridComponent;
  cols = [
    { title: this.localePipe.transform('component.MessageNotice.name'), field: 'Name', width: 60, searchField: 'Name' },
    { title: 'ID', field: 'Id', width: 90, searchField: 'Id' }];
  // ==========================================================
  actis = [];
  fullActis = [];
  pageInfo = {
    pageIndex: 1,
    pageList: [10, 20, 30, 50],
    pageSize: 20
  };
  total: number;
  messageNotice = [];
  messageNoticeValue = [];
  targetNodeID = [];
  activitySendTime = [
    { value: 'WORKITEM_CREATED', text: this.localePipe.transform('component.MessageNotice.workCreated') },
    { value: 'ACTIVITY_COMPLETED', text: this.localePipe.transform('component.MessageNotice.actComplete') },
    { value: 'ACTIVITY_ABORTED', text: this.localePipe.transform('component.MessageNotice.actAborted') },
];
  columns = [
    {
      field: 'subject', width: 100, title: this.localePipe.transform('component.MessageNotice.subject'),
    }, {
      field: 'content', width: 150, title: this.localePipe.transform('component.MessageNotice.content'), showTips: true,
    }, {
      field: 'sendTime', width: 100, title: this.localePipe.transform('component.MessageNotice.sendTime'),
      formatter: {
        type: 'enum',
        options: { valueField: 'value', textField: 'text', data: this.activitySendTime }
      },
    }, {
      field: 'sendType', width: 100, title: this.localePipe.transform('component.MessageNotice.sendType'),
      formatter: {
        type: 'enum',
        options: { valueField: 'value', textField: 'name', data: this.uistate.messageChannels.map(m => ({ value: m.code, name: m.name })) }
      },
    }, {
      field: 'receiverText', width: 120, title: this.localePipe.transform('component.MessageNotice.receiverText'), showTips: true
    }];

  constructor(
    public uistate: ProcessDesignerUIState,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
  }

  ngOnInit() {}

  endEdit(e: any) {
    console.log(e);
  }

  actisSelect = (rowData): Observable<PickedResult> => {
    for (const r of rowData) {
      this.targetNodeID.push(r.Id);
    }
    return of({
      closeDialog: true
    });
  }

  paramAfterEdit = (rowIndex: number, rowData: any, column?: DataColumn) => {
    console.log(rowData);
    console.log(rowIndex);
    return of(true);
  }

  get messageNotices() {
    return this.messageNotice;
  }

  set messageNotices(m) {
    this.messageNotice = m;
  }

  clickOK() {
    if (!this.targetNodeID && this.targetNodeID.length === 0) {
      this.message.info(this.localePipe.transform('component.MessageNotice.noTargetNode'));
      return;
    }
    if (!this.messageNotice && this.messageNotice.length === 0) {
      this.message.info(this.localePipe.transform('component.MessageNotice.noMessageNotifyAttribute'));
      return;
    }
    const batchSetValue = new MessageNoticeBatchSet();
    batchSetValue.messageNotice = this.messageNotice;
    batchSetValue.targetNodeID = this.targetNodeID;
    batchSetValue.isBatchCopy = true;
    const object = { value: batchSetValue, parameters: null };
    this.submitEmitter.emit(object);
  }

  clickCancel() {
    this.closeEmitter.emit();
  }
}
